/**
 * RouteWrapper Component
 * Handles route-level concerns (meta tags, analytics, scroll)
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { RouteMeta } from '../types';

interface RouteWrapperProps {
  children: React.ReactNode;
  meta?: RouteMeta;
}

export function RouteWrapper({ children, meta = {} }: RouteWrapperProps): JSX.Element {
  const location = useLocation();

  React.useEffect(() => {
    // Update document title
    document.title = meta.title ? `${meta.title} | Healthcare App` : 'Healthcare App';

    // Update meta description
    if (meta.description) {
      let metaEl = document.querySelector('meta[name="description"]');
      if (!metaEl) {
        metaEl = document.createElement('meta');
        metaEl.setAttribute('name', 'description');
        document.head.appendChild(metaEl);
      }
      metaEl.setAttribute('content', meta.description);
    }

    // Scroll to top
    window.scrollTo(0, 0);
  }, [location, meta]);

  return <>{children}</>;
}
